import PropTypes from 'prop-types';

const userDataPropType = {
  numberOfElements: PropTypes.number,
  totalElements: PropTypes.bool,
  content: PropTypes.shape({
    deletable: PropTypes.bool,
    engagement: PropTypes.number,
    id: PropTypes.string,
    membershipClassId: PropTypes.string,
    progress: PropTypes.shape({
      total: PropTypes.number,
      completed: PropTypes.number,
      completedPercentage: PropTypes.number
    }),
    userAccessCount: PropTypes.number,
    userEmail: PropTypes.string,
    userFirstAccessDate: PropTypes.string,
    userLastAccessDate: PropTypes.string,
    userLocale: PropTypes.string,
    userName: PropTypes.string,
    userPlusAccess: PropTypes.string,
    userPurchaseDate: PropTypes.string,
    userRole: PropTypes.string,
    userStatus: PropTypes.string,
    userType: PropTypes.string
  })
};

const commentDataProptype = {
  commentClass: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string
  }),
  commentDate: PropTypes.string,
  content: PropTypes.string,
  id: PropTypes.string,
  lastAction: PropTypes.string,
  page: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    module: PropTypes.string
  }),
  status: PropTypes.string,
  type: PropTypes.string,
  user: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    email: PropTypes.string
  })
};

export { userDataPropType, commentDataProptype };
